/*
 * Copyright (c) University of Technology Sydney. All rights reserved.
 * See LICENSE file in the project root for full license information.
 *
 * Project Name: wpt-frontend.
 * Author: Tim Porritt
 * Created: 07/03/22
 */

import BarChart from '@/components/Charts/BarChart';
import getWorkloadChartData from '@/components/Charts/getWorkloadChartData';
import { Workplan, WorkplanVersion } from '@/wpt-lib/interfaces/Workplan';
import { toArr } from '@/wpt-lib/utils/helpers';
import React from 'react';
import { useWorkplanLabels } from '@/components/contexts/LabelsContext/useLabels';
import { Assignment } from '@/wpt-lib/interfaces/Assignment';

export interface WorkloadChartProps {
    workplanVersion: WorkplanVersion | (Assignment & { workplan?: Workplan });
}

const WorkloadChart = ({ workplanVersion }: WorkloadChartProps) => {
    const workloadData = getWorkloadChartData(
        workplanVersion,
        useWorkplanLabels(workplanVersion.workplan, 'ACTIVITY', 'academicFocusArea'),
    );
    const workloadDescription = workloadData.map((v) => `${toArr(v.label).join(' ')}: ${v.target}%`).join('; ');

    return (
        <BarChart
            title="Workload Allocation Bar Chart"
            description={`A bar chart showing ${workloadDescription}`}
            data={workloadData}
            unit="%"
            maxH={400}
            maxW={600}
            minW={300}
        />
    );
};

export default WorkloadChart;
